/* eslint-disable react/prop-types, react/no-unescaped-entities */
import React, { Component } from 'react'
import {
  Container,
  Row,
  Col
} from 'reactstrap'

import 'bootstrap/dist/css/bootstrap.css'
import NavBar from './NavBar'

class App extends Component {
  render() {
    return (
      <div className="App">
        <NavBar />
        <style>{`
          .navbar-brand  span{
            color: #fed136;
            font-size:25px;font-weight:700;letter-spacing:0.1em;
              font-family: 'Kaushan Script','Helvetica Neue',Helvetica,Arial,cursive;
          }
          .navbar-brand {
          	color: #fff;
          	font-size:25px;
              font-family: 'Kaushan Script','Helvetica Neue',Helvetica,Arial,cursive;
          	font-weight:700;
          	letter-spacing:0.1em;
          }
          
          .navbar-nav .nav-item .nav-link{
          	padding: 1.1em 1em!important;
          	font-size: 120%;
              font-weight: 500;
              letter-spacing: 1px;
              color: #fff;
             font-family: 'Gothic A1', sans-serif;
          }
          .navbar-nav .nav-item .nav-link:hover{color:#fed136;}
          .navbar-expand-md .navbar-nav .dropdown-menu{
          	border-top:3px solid #fed136;
          }
          .dropdown-item:hover{background-color:#fed136;color:#fff;}
          nav{-webkit-transition: padding-top .3s,padding-bottom .3s;
              -moz-transition: padding-top .3s,padding-bottom .3s;
              transition: padding-top .3s,padding-bottom .3s;
              border: none;
          	}
          	
           .shrink {
              padding-top: 0;
              padding-bottom: 0;
              background-color: #212529;
          }
          .banner{
          	background-image:url('https://clients-yippify.s3-us-west-2.amazonaws.com/unioncitysmogshop/Hero_Image_Large.png');
          	text-align: center;
              color: #fff;
             
              background-repeat: no-repeat;
              background-attachment: scroll;
              background-position: center center;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
              height: 80vh;
          }
          .banner-text{
          	padding:200px 0 150px 0;
          }
          .banner-heading, h1 {
            font-family: 'Lobster';
          	font-size: 50px;
              font-weight: 700;
          	color:#fff;
          }
          
          @media (max-width:500px)
          {
          	.navbar-nav{
          		background-color:#000;
          		border-top:3px solid #fed136;
          		color:#fff;
          		z-index:1;
          		margin-top:5px;
          		}
          	.navbar-nav .nav-item .nav-link{
          	padding: 0.7em 1em!important;
          	font-size: 100%;
              font-weight: 500;
              }
          	.banner-text{
          	padding:150px 0 150px 0;
          }
          .banner-heading, h1 {
          	font-size: 30px;
              margin-bottom: 20px;
          }
          }
          
          @media (max-width:768px){
          .banner-heading, h1 {
          	font-size: 30px;
              margin-bottom: 20px;
          }
          	.banner-text{
          	padding:150px 0 150px 0;
          }
          }        
          section {
            padding-top: 38px;
            padding-bottom: 38px;
          }
          h2 {
            text-align: center!important;
          }
        `}</style>
        <div className='banner'>
          <Container>
            <div className='banner-text'>
              <div className='banner-heading'>
                <h1>Union City Smog Check</h1>
                Fast, Friendly, & Affordable Test Only Smog Checks
              </div>
            </div>
          </Container>
        </div>
        <section id='services'>
          <Container>
            <Row>
              <Col xs='12' sm='4' className='text-center'>
                <img alt='Star Certified Test Only' src='https://assets.unioncitysmogcheck.com/unioncitysmogshop/Smog_Certification_logo1.png' className='img-fluid' />
              </Col>
              <Col xs='12' sm='8'>
                <h2>Our Guaranteed Service</h2> 
                <p>
                Union City Smog Check is a STAR Certified Test Only Smog Station located in Union City, California. Our main goal is to provide unbiased test only smog checks to the people of Union City.
                </p>
                <p>
                We also are known to cater to surrounding cities such as Fremont and Hayward as well.
                </p>
                <p>
                We guarantee that your smog test will only take 15-20 minutes max. To speed things up, if you are short on time, call in to schedule an appointment so that we can get you in and out even faster!
                </p>
                <p>
                We pride ourselves in giving our customers the best treatment possible. We sit down with each of customers to go over test results or answer any questions you may have during your visit.
                </p>
              </Col>
            </Row>
          </Container>
        </section>
        <section id='about-us' style={{ backgroundColor: '#41a6cb', color: '#fff' }}>
          <Container>
            <Row>
              <Col xs='12'>
                <h2>About Us</h2> 
                <h3>What makes us different from the rest?</h3>
                <p>
                Union City Smog Check was established in 2012. Since then, we have developed a trust from our customers that continue to come back year after year to have their smog checks done by us.
                </p>
                <div className="embed-responsive embed-responsive-16by9">
                  <iframe className="embed-responsive-item" src="https://player.vimeo.com/video/124367672" allowFullScreen></iframe>
                </div>
                <p>
                We are a family owned small business that cares GREATLY about our customers. Unlike other smog stations, we ensure our customers are treated with respect and given the attention they deserve.
                </p>
                <p>
                In addition to Union City, we also support surrounding cities such as Fremont and Hayward.
                </p>
                <p>
                Union City Smog Check specializes in providing test only smog checks for all vehicles needing this due to change of ownership, test only, gross polluters, etc.
                </p>
              </Col>
            </Row>
          </Container>
        </section>
        <img className="img-fluid" width="100%" src="https://assets.unioncitysmogcheck.com/unioncitysmogshop/Union_City_Smog_Check_collage_Large.png" alt="Union City Smog Check" />          
        <section id="smog-tips">
          <Container>
            <Row>
              <Col xs="12">
                <h2>Smog Passing Tips</h2>
                <dl>
                  <dt>Running Right</dt>
                  <dd>Do not get an emissions test if you suspect your vehicle is not driving, running or functioning properly. Consider this, many vehicles do not pass the emissions test although their owners never suspected any problems. They're simply shocked when they find out. Now, if your vehicle is already experiencing obvious problems, don't waste time or money on a smog check. More then unlikely it will not pass the emissions test and you will lose your inspection fee. Seek repair assistance first. This will ensure your vehicle passes the emissions test the first time. Plan ahead.</dd>
                  <dt>Check Engine light Off</dt>
                  <dd>Check engine light should not be on. An illuminated check engine light will cause your vehicle to not pass the emissions test automatically. A certified emissions repair shop can use a trouble code retrieval tool to extract trouble code data from the ECU and perform necessary repairs to turn the check engine light off.</dd>
                  <dt>Inflate Tires</dt>
                  <dd>As mentioned above, during the smog inspection the smog technician may need to drive your vehicle on a dynamometer. Insuring your vehicle's tire pressures are even and correct will help you pass the emissions test. Correct tire pressure will allow the vehicle to be driven with greater stability and control during the emissions test. This will greatly improve your chances of passing the emission test by allowing the engine to maintain a constant and steady load. Accurate tire pressure (as required by the tire and vehicle manufacturer) may be the deciding factor between a borderddne vehicle passing or not passing the emissions test.</dd>
                  <dt>Change Engine Oil</dt>
                  <dd>If you haven't performed an oil change within the last 5,000 miles, go ahead and do it before the emissions test. This will assist in getting passing emission test results. Your vehicle's Positive Crank Ventilation (PCV) system is designed to allow the engine to breath fumes from the oil compartments. The fumes are then burned through the combustion process. If the oil in your engine is contaminated due to inadequate oil changes it may very well cause your vehicle to fail the emissions test. Contaminated oils are high in Hydrocarbons (HC) and will present a rich mixture to the combustion chambers. Not performing regularly required oil and filter changes not only causes premature engine wear but can also cause your vehicle to not pass the emissions inspection.</dd>
                  <dt>Take a Drive</dt>
                  <dd>Drive your vehicle for at least 20 minutes prior to arriving at the smog station. This will ensure your coolant, oil, and catalytic converter reach and maintain optimum operating temperature. This will help your vehicle pass the emissions test as well. Remember your engine is a fuel-burning machine. To ensure a passing emissions test and adequate combustion it needs to have sufficient time to warm-up and this can be accomplished through driving for at least 10 to 15 miles. Emission test standards require smog check technicians to ensure a vehicle is at proper operating temperatures prior to administering the emissions test, however this is one conditioning that will help pass the emissions test that you can perform as well.</dd>
                  <dt>Use Fuel Additives</dt>
                  <dd>Fuel additives can be very helpful in lowering emission levels and helping your car, truck, van or SUV pass the emissions inspection. Fuel additives are generally poured into a vehicle's gas tank during fuel refueling. The additive is mixed with your vehicle's fuel. The purpose is to clean carbon deposits within your engine's intake and exhaust paths, allowing for both fuel and air to flow freely within its passages, thus lowering emission levels, improving combustion, increasing overall engine performance, and helping you pass the emission test. These types of products offer helpful solutions to various vehicle emission and smog test problems.</dd>
                  <dt>Avoid Wet Weather</dt>
                  <dd>Try to pick a nice day to have your vehicle tested. This will help your car pass the emissions test. Avoid the rain. Let us point out a few problems with rainy days. Your vehicle (assuming it's registered in one of the larger counties in California) will need to be driven on a dynamometer during the emissions test. Obviously when wet, your car's tires will be stopping and losing traction as the smog technician tries to maintain required test speeds. Unstable engine and drivetrain torque is not the best conditioning your vehicle should receive if you plan on getting passing emissions test results. You want your vehicle's engine running super comfortable, not high stress. This is not to say you can't get a passing emissions test on a rainy day, certainly not. The smog machine has a "dry tires" mode, which will dry your vehicle's tires before the test. However as we mentioned, you don't want to place any extra strain on the engine before or during the emissions test.</dd>
                  <dt>Battery Recently Disconnected?</dt>
                  <dd>If your vehicle's battery has recently been disconnected due to it having needed replacement or battery charging, or if your vehicle recently needed a jump start, we recommend holding off on getting the smog check for at least one week while you drive your vehicle regularly. Chances are while your vehicle's computer lost power, its internal self-test monitors were erased. Without these important and required emission monitors your vehicle cannot pass the smog test. You will be required to drive between 100-200 miles and over the course of a week in order to reset or "complete" the emission monitors. This period of driving is referred to as a "Drive Cycle".</dd>
                </dl>          
              </Col>
            </Row>
          </Container>
        </section>
        <section id='our-gift' style={{ backgroundColor: '#eb212e', color: '#fff' }}>
          <Container>
            <Row>
              <Col xs='12' sm='4' className="align-baseline text-center">
                <img alt='gift from Union City Smog Check' src='https://assets.unioncitysmogcheck.com/unioncitysmogshop/Gift_Icon.png' className='img-fluid' />
              </Col>
              <Col xs='12' sm='8' className="align-middle mt-3">
                <h2>Our Gift to You</h2>
                <p>
                Mention that you visited our website to the smog technician, and get $20 off our normal pricing. If you don’t pass, don’t worry we include a FREE re-test at no additional cost!
                </p>
                <p>
                There are no hidden costs, tricks or gimmicks. Just one FLAT fee!
                </p>
              </Col>
            </Row>
          </Container>
        </section>
        <section id="contact-us">
          <Container>
            <Row>
              <Col xs="12" md="6">
                <div className="embed-responsive embed-responsive-16by9 mb-3">
                  <iframe title="unicon city address" className="embed-responsive-item" 
                    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3160.8442861287194!2d-122.02033770000001!3d37.6058236!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808f956b6c3c78cb%3A0x2d39f15ea1b1a105!2s33365+Mission+Blvd%2C+Union+City%2C+CA+94587!5e0!3m2!1sen!2sus!4v1428677828662" 
                    allowFullScreen />
                </div>
              </Col>
              <Col xs="12" md="6">
                <p>33365 Mission Blvd., Union City, CA 94587</p>
                <p>Monday through Saturday – 9AM to 5PM.</p>
                <p><a href="tel:5104419800" rel="nofollow">1 (510) 441-9800</a></p>
                <p><a href="mail:unioncitysmogcheck@gmail.com" rel="nofollow">unioncitysmogcheck@gmail.com</a></p>
                <h6>See what others have been saying about Union Smog Check!</h6>
                <a href="https://www.facebook.com/UnionCitySmogCheck" target="_blank" rel="noopener noreferrer">Facebook</a>{' '}
                <a href="http://www.yelp.com/biz/union-city-smog-check-union-city" target="_blank" rel="noopener noreferrer">Yelp</a>
              </Col>
            </Row>
          </Container>
        </section>        
        <footer>
        <p className="text-center">@2018 Union City Smog Check - Designed by <a href="https://yippify.com">Yippify</a></p>
        </footer>        
      </div>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js